import { Box, type BoxProps } from '@mantine/core';
import type { ReactNode } from 'react';

export type ModalContentProps = BoxProps & {
  children: ReactNode;
};

/**
 * Content container for Mantine Modal with consistent padding.
 * Matches ui-lib DialogContent styling.
 */
export const ModalContent = ({ children, ...props }: ModalContentProps) => (
  <Box p="1rem" {...props}>
    {children}
  </Box>
);
